<template>
    <FormModel
            :action="submit" :labelCol="{span:4}" :model="config.flow_policy"
            :rules="rules" :wrapperCol="{span: 20}" style="width: 560px;">
        <a-alert :show-icon="true" type="warning">
            <div slot="message">
                * 根据使用场景情况设置合理的压缩尺寸及发布流程
            </div>
        </a-alert>
        <a-form-model-item label="压缩策略" prop="resize_long" style="margin-top: 15px;">
            <a-radio-group v-model="config.flow_policy.resize_long">
                <a-radio :style="radioStyle" :value="0">原图，不压缩</a-radio>
                <a-radio :style="radioStyle" :value="2400">图片长边为2400px</a-radio>
                <a-radio :style="radioStyle" :value="2000">图片长边为2000px</a-radio>
                <a-radio :style="radioStyle" :value="1600">图片长边为1600px</a-radio>
            </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="上传策略" prop="upload_type">
            <a-radio-group v-model="config.flow_policy.upload_type">
                <a-radio :value="1">全部图片自动上传</a-radio>
                <a-radio :value="2">手动选择图片上传</a-radio>
            </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="发布策略" prop="release_type">
            <a-radio-group v-model="config.flow_policy.release_type">
                <a-radio :value="1">上传图片自动发布</a-radio>
                <a-radio :value="2">手动选择图片发布</a-radio>
                <a-radio :disabled="config.flow_policy.retouch_type===3" :value="3">完成修图自动发布</a-radio>
            </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="修图策略" prop="retouch_type">
            <a-radio-group v-model="config.flow_policy.retouch_type">
                <a-radio :value="1">上传图片全部修图</a-radio>
                <a-radio :value="2">手动选择图片修图</a-radio>
                <a-radio :disabled="config.flow_policy.release_type===3" :value="3">发布图片全部修图</a-radio>
            </a-radio-group>
        </a-form-model-item>
    </FormModel>
</template>

<script>
   import func from "../../../../utils/func";
   import cache from "../../../../utils/cache";
   import FormModel from "../../../../comps/FormModel";

   export default {
      name: "config.flow_policy",
      props: {album: Object},
      components: {FormModel},
      data() {
         return {
            config: {
               flow_policy: {
                  resize_long: 1600,
                  upload_type: 1,
                  release_type: 1,
                  retouch_type: 2,
               }
            },
            radioStyle: {
               height: '30px',
               lineHeight: '30px',
               display: 'block',
            },
            rules: {
               resize_long: {required: true},
               upload_type: {required: true},
               release_type: {required: true},
               retouch_type: {required: true},
            }
         }
      },
      mounted() {
         this.config = func.copyObject(this.album.config);
      },
      methods: {
         submit() {
            return cache.v1.album.setConfig(this.album.id, this.config)
               .then(() => this.album.config = this.config);
         }
      }
   }
</script>
